import React from 'react';
import { ResourceCenter } from 'cccisd-laravel-resources';

function Resources() {
    return <ResourceCenter handle="default" />;
}

export default Resources;
